import { Dictionary } from "./dictionary";

/**
 * An error response contains a description, correlationId and a list of errors
 */
export interface ErrorResponse {
    description: string,
    correlationId: string,
    errors: CustomError[];
}

/**
 * A custom error contains a message, code and parameters (witch can be used for model validation)
 */
export interface CustomError extends Error {
    message: string;
    code: string;
    parameters: Dictionary<object>;
}

/**
 *  Check if the error is of type ErrorResponse
 * @param error Any error
 * @returns True if the error is of type ErrorResponse
 */
export function isErrorReponseType(error: any): error is ErrorResponse {
    return error.message 
    && error.correlationId 
    && error.errors !== undefined 
    && error.errors instanceof Array 
    && isCustomErrorType(error.errors[0]);
}

/**
 * Check if the error is of type CustomError
 * @param error any error
 * @returns True if the error is of type CustomError 
 */
export function isCustomErrorType(error: any): error is CustomError {
    return error.code !== undefined && error.parameters !== undefined;
}